import React from "react";
import { Title } from "../../components/Title";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { Link } from "../../components/Link";

export const CognitoProject = () => {
  const { t } = useTranslation();
  return (
    <div className="cognito-project">
      <section>
        <div className="inner">
          <Title title={t("solution.cognito.project.title")}></Title>

          <div className="project-item">
            <div className="item-img">
              <img
                src="//files.authing.co/authing-website/cognito-framework-design-new.png"
                alt="authing cognito framework"
              />
            </div>
            <div className="item-text">
              <div className="title">{t("solution.cognito.project.item1.title")}</div>
              <div className="descript-title">{t("solution.cognito.project.item1.subtitle")}</div>
              <div className="descript-list">
                <span className="descript-list-icon">
                  <i className="icon authing-icon authing-wancheng authing-mark icon-style"></i>
                </span>
                {t("solution.cognito.project.item1.list1")}
              </div>
              <div className="descript-list">
                <span className="descript-list-icon">
                  <i className="icon authing-icon authing-wancheng authing-mark icon-style"></i>
                </span>
                {t("solution.cognito.project.item1.list2")}
              </div>
              <div className="descript-list">
                <span className="descript-list-icon">
                  <i className="icon authing-icon authing-wancheng authing-mark icon-style"></i>
                </span>
                {t("solution.cognito.project.item1.list3")}
              </div>
              <div className="descript-list">
                <span className="descript-list-icon">
                  <i className="icon authing-icon authing-wancheng authing-mark icon-style"></i>
                </span>
                {t("solution.cognito.project.item1.list4")}
              </div>
              <div className="descript">
                <span style={{ marginRight: 4 }}>{t("solution.cognito.project.item1.tip")}</span>
                <Link href="https://authing.demo.cbuilder.tech/" rel="noopener noreferrer" target="_blank">
                  {t("solution.cognito.project.item1.link")}
                </Link>
              </div>
            </div>
          </div>
          <div className="project-item">
            <div className="item-text">
              <div className="title">{t("solution.cognito.project.item2.title")}</div>
              <div className="descript" style={{ color: "#9BA1A7", marginBottom: 10 }}>
                {t("solution.cognito.project.item2.subtitle")}
              </div>
              <div className="descript-list">
                <span className="order first-order">01</span>
                {t("solution.cognito.project.item2.list1")}
              </div>
              <div className="descript-list">
                <span className="order second-order">02</span>
                {t("solution.cognito.project.item2.list2")}
              </div>
              <div className="descript-list">
                <span className="order third-order">03</span>
                {t("solution.cognito.project.item2.list3")}
              </div>
            </div>
            <div style={{ marginRight: 60 }}>
              <div className="item-img">
                <img src="//files.authing.co/authing-website/cognito-login-token-new.png" alt="authing cognito token" />
              </div>
              <div className="item-img-text">
                {t("solution.cognito.project.item2.imgText")}
                <Link
                  href="https://www.scottbrady91.com/OpenID-Connect/OpenID-Connect-Flows"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {t("solution.cognito.project.item2.link")}
                </Link>
              </div>
            </div>
          </div>
          <div className="project-item">
            <div className="item-img">
              <img src="//files.authing.co/authing-website/cognito-api-gateway-new.png" alt="authing cognito gateway" />
            </div>
            <div className="item-text">
              <div className="title">{t("solution.cognito.project.item3.title")}</div>
              <div className="descript">{t("solution.cognito.project.item3.subtitle")}</div>
            </div>
          </div>
          <div className="project-item">
            <div className="item-text">
              <div className="title">{t("solution.cognito.project.item4.title")}</div>
              <div className="descript">{t("solution.cognito.project.item4.subtitle")}</div>
            </div>
            <div className="item-img" style={{ marginRight: 60 }}>
              <img
                src="//files.authing.co/authing-website/cognito-identity-pool-new.png"
                alt="authing cognito identity"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
